<section *ngIf="generating" class="no print">
  Generating...close when complete.
</section>
<section class="p-b-16">
  <div class="m-t-16 no print flex flex-row gap-2">
    <button type="button" mat-stroked-button color="primary" (click)="print()">
      Print Form
   </button>

   <button type="button" mat-stroked-button color="primary" (click)="print()">
      Export to PDF
   </button>

    <button type="button" mat-stroked-button color="warn" (click)="cancel()">Close</button>
  </div>
</section>
  <mat-dialog-content>
    <kendo-pdf-export #pdf
      paperSize="letter"
      [scale]="0.75"
      margin="1cm">
      <div id="paymentSlip" #paymentSlip class="f-s-16 flex flex-col gap-4 text-black" role="document">
        <header class="flex flex-row gap-1">
          <div class="flex flex-col flex-1">
            <h2 class="f-s-18" style="margin-bottom: -0.5rem;"><strong>PUBLIC HEALTH DIVISION</strong></h2>
            <h3 class="f-s-18" style="margin-bottom: -0.5rem;"><strong>CENTER FOR HEALTH PROTECTION</strong></h3>
            <p style="margin-bottom: -0.7rem;"><strong>Oregon Psilocybin Services</strong></p>
            <p><a href="http://oregon.gov/psilocybin">http://oregon.gov/psilocybin</a></p>
          </div>
          <img class="p-4" src="../../../../../assets/images/OHA-Color-Small.png" alt="Oregon Health Authority Logo">
        </header>

        <h1 class="flex flex-row justify-center">
          <span class="f-s-18"><strong>{{pageTitle}} </strong></span>
        </h1>

        <section *ngIf="showTrainingProgram" class="flex flex-col gap-1" aria-label="Training Program Information">
          <dl class="flex flex-col gap-1">
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>Name</strong></dt>
              <dd>{{licenseName}}</dd>
            </div>
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>Responsible Party(RP) Name</strong></dt>
              <dd>{{responsiblePartyName}} </dd>
            </div>
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>RP Phone Number</strong></dt>
              <dd>{{responsiblePartyPhone | mask:'(000)-000-0000 000000'}}</dd>
            </div>
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>RP Email</strong></dt>
              <dd>{{responsiblePartyEmail}}</dd>
            </div>
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>TLC ID Number (if known)</strong></dt>
              <dd>{{licenseId}}</dd>
            </div>
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>Application Date</strong></dt>
              <dd>{{applicationDate}}</dd>
            </div>
          </dl>
        </section>

        <section *ngIf="!showTrainingProgram" class="flex flex-col gap-1" aria-label="Licensee Information">
          <dl *ngIf="!isEntityLicense" class="flex flex-col gap-1">
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>{{individualType}} Name</strong></dt>
              <dd>{{responsiblePartyName}} </dd>
            </div>
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>{{individualType}} Phone Number</strong></dt>
              <dd>{{responsiblePartyPhone | mask:'(000)-000-0000 000000'}}</dd>
            </div>
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>{{individualType}} Email</strong></dt>
              <dd>{{responsiblePartyEmail}}</dd>
            </div>
          </dl>

          <dl *ngIf="isEntityLicense" class="flex flex-col gap-1">
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>Licensee Name</strong></dt>
              <dd>{{licenseName}}</dd>
            </div>
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>Point of Contact Name</strong></dt>
              <dd>{{responsiblePartyName}} </dd>
            </div>
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>Point of Contact Phone Number</strong></dt>
              <dd>{{responsiblePartyPhone | mask:'(000)-000-0000 000000'}}</dd>
            </div>
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>Point of Contact Email</strong></dt>
              <dd>{{responsiblePartyEmail}}</dd>
            </div>
          </dl>

          <dl class="flex flex-col gap-1">
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>TLC ID Number</strong></dt>
              <dd>{{licenseId}}</dd>
            </div>
            <div class="flex flex-row">
              <dt class="w-[35%]"><strong>Application Date</strong></dt>
              <dd>{{applicationDate}}</dd>
            </div>
          </dl>
        </section>

        <section class="flex flex-row gap-2 justify-center" aria-label="Payment Selection">
          <div class="flex flex-col gap-2 justify-start items-center w-1/2">
            <h3 id="PaymentType"><strong>Payment Type</strong></h3>
            <mat-radio-group aria-labelledby="PaymentType" class="flex flex-col">
              <mat-radio-button value="1" color="primary" class="radio-button">Cashier's Check</mat-radio-button>
              <mat-radio-button value="2" color="primary" class="radio-button">Money Order</mat-radio-button>
              <mat-radio-button value="3" color="primary" class="radio-button">Personal/Business Check</mat-radio-button>
              <mat-radio-button value="4" color="primary" class="radio-button">Cash <strong>(Please Do Not Mail Cash Payments)</strong>
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="flex flex-col gap-2 justify-start items-center w-1/2">
            <h3 id="PaymentPurpose"><strong>Payment Purpose</strong></h3>
            <mat-radio-group aria-labelledby="PaymentPurpose" class="flex flex-col">
              <!-- Worker Permit -->
              <mat-radio-button value="5" color="primary" class="radio-button" *ngIf="showWorkerPermit && !civilPenalty">New Application Fee $25</mat-radio-button>
                <mat-radio-button value="8" color="primary" class="radio-button" *ngIf="showWorkerPermit && civilPenalty">Civil Penalty Fee ${{data.amount}}</mat-radio-button>
              <!--Licenses-->
              <div *ngIf="!showWorkerPermit" class="flex flex-col">
                <mat-radio-button value="5" color="primary" class="radio-button" *ngIf="application">New Application Fee {{applicationFee}}</mat-radio-button>
                <mat-radio-button value="6" color="primary" class="radio-button" *ngIf="annual">Annual License Fee {{annualFee}}</mat-radio-button>
                <mat-radio-button value="8" color="primary" class="radio-button" *ngIf="reduced">Reduced Annual License Fee {{reducedFee}}</mat-radio-button>
                <mat-radio-button value="8" color="primary" class="radio-button" *ngIf="changeRequest">Change Request Fee{{changeRequestFee}}</mat-radio-button>
                <mat-radio-button value="8" color="primary" class="radio-button" *ngIf="changeLocation">Change of Location Fee {{changeLocationFee}}</mat-radio-button>
                <mat-radio-button value="8" color="primary" class="radio-button" *ngIf="civilPenalty">Civil Penalty Fee ${{data.amount}}</mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </section>

        <span class="flex-1"></span>

        <section aria-label="Payment Instructions">
          <h3 class="flex flex-row justify-center items-start">
            <strong>Instructions for Submitting the Fee Payment by Mail or In-Person</strong>
          </h3>

          <div class="flex flex-col">
            <p>Money orders and checks are payable to: <strong>Oregon Psilocybin Services</strong></p>
            <p>
              Personal and business checks will be held for 21 days to ensure payment clearance.
            </p>
          </div>

          <div class="flex flex-col">
            <h3><strong>Mail the money order or check AND remittance form to:</strong></h3>
            <address>
              Oregon Health Authority - Public Health Division - Fiscal Services<br>
              RE: OPS, PO Box 14260, Portland, OR 97293-0260
            </address>
          </div>

          <div class="flex flex-col">
            <h3><strong>To make an in-person payment with a money order or check:</strong></h3>
            <p>
              Visit the Cashier's Office on the
              second floor of the Portland State Office Building at 800 NE Oregon St, Suite 200, Portland, OR 97232 - Hours:
              9am to 4pm, Monday to Friday
            </p>
          </div>

          <p>
            Additional instructions: The Cashier's Office window is located on the second floor next to the Vital Health
          Statistics window.
          If security asks if you have an appointment, you may let them know you are dropping off a payment for Oregon
          Psilocybin Services at the
          Cashier's Office window which does not require an appointment. <u>Please include the remittance form with the
          payment. Appointments are required for cash payments.</u>
          </p>

          <div class="flex flex-col">
            <h3><strong>To make cash payment arrangements or for payment questions, please contact:</strong></h3>
            <address class="flex flex-row gap-2 justify-start items-center">
              <span>licensing.psilocybin&#64;oha.oregon.gov </span>
              <span>or (971) 341-1509</span>
            </address>
          </div>
        </section>

      </div>
    </kendo-pdf-export>
  </mat-dialog-content>
